const getPlaceholderFromFragment = (hash: string): string | null => {
  if (!hash || hash.length <= 1) return null;

  // Remove leading '#' and parse as query string
  const fragmentParams = new URLSearchParams(hash.slice(1));
  return (
    fragmentParams.get('placeholder_url') || fragmentParams.get('placeholder')
  );
};

export const convertSignedUrlsToRedirectUrls = (html: string): string => {
  if (!html) return html;

  const parser = new DOMParser();
  const document = parser.parseFromString(html, 'text/html');
  const images = document.querySelectorAll('img');

  let hasPlaceholder = false;

  for (const img of images) {
    const source = img.getAttribute('src');
    if (!source) continue;

    try {
      const url = new URL(source);

      // Check query params first, then fragment
      const placeholderParameter =
        url.searchParams.get('placeholder_url') ||
        url.searchParams.get('placeholder') ||
        getPlaceholderFromFragment(url.hash);

      if (placeholderParameter) {
        hasPlaceholder = true;
        img.setAttribute('src', decodeURIComponent(placeholderParameter));
      }
    } catch {
      // If URL parsing fails (e.g., relative URLs, data URLs), skip this image
      continue;
    }
  }

  return hasPlaceholder ? document.body.innerHTML : html;
};
